/** Rank NIST 1:N gallery match decisions per FRVT semantics. */

export const MODALITY_FACE = 'FACE';
export const MODALITY_IRIS = 'IRIS';

export function rankGalleryDecisions(decisions, modality = MODALITY_FACE) {
  if (!decisions?.length) return [];
  const ascending = modality === MODALITY_IRIS;
  return [...decisions].sort((a, b) => {
    const sa = a.score ?? (ascending ? Number.POSITIVE_INFINITY : -1);
    const sb = b.score ?? (ascending ? Number.POSITIVE_INFINITY : -1);
    return ascending ? sa - sb : sb - sa;
  });
}

export function applyTopK(ranked, topK) {
  if (!ranked?.length) return [];
  const k = Math.max(1, Math.min(Number(topK) || ranked.length, ranked.length));
  return ranked.slice(0, k);
}

export function pickBestGalleryMatch(decisions, modality = MODALITY_FACE) {
  const ranked = rankGalleryDecisions(decisions, modality);
  return ranked[0] || null;
}
